import {SET} from './constants';

export const set = (data) => ({type: SET, data});

export const startLoading = () => ({type: SET, data: {loading: true}});

export const stopLoading = () => ({type: SET, data: {loading: false}});
